import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/pages/services.css";
import Services from "../module/Services";
import WhyUs from "../module/Why-Us";
import Process from "../module/Process";

import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
// import bg3 from "../../assets/images/img/bg-3.svg";

export default function OurServices() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" className="" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section section__services">
          {/* <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          /> */}
          <div className="container services">
            <h5 id="scroll" className="drop-from-top">
              Our Services
            </h5>
            <div className="title drop-from-top">
              <h2 style={{ marginBottom: "30px" }}>
                We work for your ideas
              </h2>
            </div>
            <div className="description">
              <p className="slide-from-left">
                At <b>Genvix Tech,</b> we offer everything you need to
                elevate your brand in the digital world—and beyond. Our
                services span across full-scale digital marketing, custom
                e-commerce solutions, graphic design and branding, and
                end-to-end development of responsive websites and mobile
                applications. Whether it's building a striking online
                presence or delivering tailored system integrations, we
                ensure every solution reflects your brand's identity and
                goals.
              </p>
              <p className="slide-from-right">
                We specialize in delivering high-quality, custom-built
                projects at competitive rates. While creating fast, secure,
                and user-friendly websites or apps is often the foundation,
                our work goes far beyond. We guide businesses through every
                phase of their digital transformation—leveraging clean code,
                scalable architecture, data-driven insights, and our
                in-house innovations to deliver measurable results. At
                Genvix Tech, we don’t just build digital products—we build
                digital success stories.
              </p>
            </div>
          </div>
        </div>

        {/* Embedded Interactive Services Module Component */}
        <Services />

        <WhyUs hideBackgroundImage={true} />
      </div>
      <Process />
    </>
  );
}
